"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _chromeIcon = _interopRequireDefault(require("../../img/chrome-icon.png"));

var _firefoxIcon = _interopRequireDefault(require("../../img/firefox-icon.png"));

var _safariIcon = _interopRequireDefault(require("../../img/safari-icon.png"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IEOverlay = function IEOverlay() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-title"
  }, "For the best experience, please use one of the following supported browsers:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.google.com/chrome/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _chromeIcon.default,
    className: "ie-overlay-browser-icon",
    alt: "Chrome"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.apple.com/safari/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _safariIcon.default,
    className: "ie-overlay-browser-icon",
    alt: "Safari"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.mozilla.org/en-US/firefox/new/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _firefoxIcon.default,
    className: "ie-overlay-browser-icon",
    alt: "Firefox"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-subtitle"
  }, "Thanks for understanding!"));
};

var _default = IEOverlay;
exports.default = _default;